import { NgFor } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { NoticiasService } from "../../../servicios/noticias/noticias.service";
import { NoticiaComponent } from "../noticia/noticia.component";
import { Noticia } from "@src/app/models/interfaces/noticia.interface";

@Component({
  selector: "app-bloque-patrocinados",
  templateUrl: "./bloque-patrocinados.component.html",
  styleUrls: ["./bloque-patrocinados.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [NoticiaComponent, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BloquePatrocinadosComponent implements OnInit {
  noticias: Noticia[] = [];
  @Input() idSeccion;
  @Input() idStart: number;

  @ViewChild("publiBloquePatrocinados", { static: false }) publiBloquePatrocinados: ElementRef<HTMLDivElement>;

  constructor(
    private readonly noticiasService: NoticiasService,
    private readonly cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const sectionNews = this.noticiasService.getNoticiasSeccion(this.idSeccion, 8, "subcanal", null);
    if (sectionNews) {
      firstValueFrom(sectionNews).then((noticias) => {
        this.noticias = noticias;
        this.cd.detectChanges();
      });
    }
  }

  trackByNoticia(index: number, noticia: any): number {
    return noticia;
  }
}
